import Vue from "vue";
import App from "./App.vue";
import router from "./router";

// libraries
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import "./registerServiceWorker";
import Carousel3d from 'vue-carousel-3d';
import $ from 'jquery';
window.$ = $

// Global Components
import PageHeader from '@/components/Wrapper/Header';
import PageFooter from '@/components/Wrapper/Footer';

Vue.config.productionTip = false;

Vue.use(Buefy);
Vue.use(Carousel3d)

Vue.component('PageHeader', PageHeader);
Vue.component('PageFooter', PageFooter);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
